import React, { useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Col, Container, Row } from "react-bootstrap"

import StoryCard from "../../internal/storyCard/StoryCard"
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import PaginationControls from "../../internal/paginationControls/PaginationControls"

import * as styles from "./StoryListingPanel.module.scss"


function TruncateString(str,limit) {
  if(str && str.length > limit) {
    return str.substring(0, limit) + "..."
  }
  return str
}


const PER_PAGE = 9
const StoryListingPanel = ({ blok, cardData, topicData }) => {
  // const initialData = cardData ? cardData.filter((d,idx)=>{return idx < PER_PAGE}) : []
  const numPages = Math.ceil(cardData.length / PER_PAGE)
  const topicList = topicData.filter((t)=>{return !t.exclude_from_listing_filters})
  
  const [currentFilter,setCurrentFilter] = useState("")
  const [currentPage,setCurrentPage] = useState(1)
  const [cards,setCards] = useState(cardData)

  const intl = useIntl()

  const updateFilter = (value) => {
    setCurrentFilter(value)
    if(value) {
      setCards(cardData.filter((card)=>{
        let t = card.topics.find((cardTopic)=>{return cardTopic.uuid===value})
        return t ? true : false
      }))
    } else {
      setCards(cardData)
    }
  }

  const onClickFilter = (topicUuid) => {
    updateFilter(topicUuid)
    if(currentPage !== 1) {
      setCurrentPage(1)
    }
  }

  const handlePageChanged = (page) => {
    setCurrentPage(page)
  }

  const handleSelectChanged = (e) => {
    updateFilter(e.target.value)
  }

  return (
    <PanelWrapper blok={blok}>
      <Container>
        <Row>
          <div className={styles.mobileOnly}>
            <select value={currentFilter} onChange={handleSelectChanged}>
              <option value="">{intl.messages["component.panel.story_listing_panel.filter_title"]}</option>
              {topicList.map((topic)=>(
                <option key={topic.id} value={topic.uuid}>{topic.display_name}</option>
              ))}
            </select>
          </div>
          <Col xs={12} md={3} className={styles.desktopOnly}>
            <h4><FormattedMessage id="component.panel.story_listing_panel.filter_title"/></h4>
            <ul className={styles.filterList}>
              <li className={currentFilter === "" ? styles.active : ""}>
                <button onClick={()=>{onClickFilter("")}}><FormattedMessage id="component.panel.story_listing_panel.filter_all"/></button>
              </li>
              {topicList.map((topic)=>(
                <li className={currentFilter === topic.uuid ? styles.active : ""} key={topic.id}>
                  <button onClick={()=>{onClickFilter(topic.uuid)}}>{topic.display_name}</button>
                </li>
              ))}
            </ul>
          </Col>
          <Col xs={12} md={9}>
            <Row>
              {cards.filter((card,idx)=>{
                // Filter current page
                return (idx+1 > ((currentPage-1)*PER_PAGE) && idx+1 <= PER_PAGE*currentPage)
              }).map((card)=>(
                <Col xs={12} md={6} lg={4} key={card.id}>
                  <StoryCard
                    image={card.image}
                    thumbnail={card.thumbnail}
                    date={card.date}
                    headline={card.headline}
                    excerpt={TruncateString(card.excerpt, 120)}
                    cta_text={(<FormattedMessage id="component.panel.story_listing_panel.cta"/>)}
                    cta_link={card.link} />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        <div>
          <br/>
          <div style={{float: "right"}}>
            {numPages > 1 ? (
              <PaginationControls numPages={numPages} currentPage={currentPage} onClickPage={handlePageChanged} />
            ) : null}
          </div>
          <div style={{clear: "both"}} />
        </div>
      </Container>
    </PanelWrapper>
  )
}

export default StoryListingPanel